import { configureStore } from "@reduxjs/toolkit";
import dashboard from "./reducers/resellerAgentDashboard";
import creditCard from "./reducers/creditCard";
import costBreakdown from "./reducers/costBreakdown";
import auth from "./reducers/authSlice";
import healthReducer from "./reducers/healthCheckSlice";

export const store = configureStore({
  reducer: {
    auth: auth,
    dashboard: dashboard,
    creditCard: creditCard,
    costBreakdown: costBreakdown,
    health: healthReducer,
  },
});
